<!-- favor.wxml -->
<template>
    <div class="favor-box">
        <div class="divider-line"></div>
        <div class="swiper-tab">
            <div :class="['swiper-tab-item',scoreType == -1 ? 'active' : '']" @click="swichNav(-1)">全部 ({{ total.all }})</div>
            <div :class="['swiper-tab-item',scoreType == 10 ? 'active' : '']" @click="swichNav(10)">好评 ({{ total.praise }})</div>
            <div :class="['swiper-tab-item',scoreType == 20 ? 'active' : '']" @click="swichNav(20)">中评 ({{ total.review }})</div>
            <div :class="['swiper-tab-item',scoreType == 30 ? 'active' : '']" @click="swichNav(30)">差评 ({{ total.negative }})</div>
        </div>
        <!-- favor -->
        <div class="favor-list-box">
            <nut-infiniteloading
                @loadmore="loadMoreVert"
                :is-show-mod="true"
                :has-more="isHasMore"
                :is-loading="isLoading"
                :threshold="200"
            >
                <div class="favor-list" v-if="common_list.length">
                    <div class="favor-item" v-for="(item,index) in common_list" :key="index">
                        <div class="user-info">
                            <div class="img">
                                <img :src="item.user.avatarUrl">
                            </div>
                            <div class="name">{{item.user.nickName}}</div>
                            <div class="pf">
                                <div v-if="item.score == 10">
                                    <nut-rate
                                        value="5"
                                        size="14"
                                        spacing="1"
                                        :readOnly="true"
                                    >
                                    </nut-rate>
                                </div>
                                <div v-else-if="item.score <30 ">
                                    <nut-rate
                                        value="1"
                                        size="14"
                                        spacing="1"
                                        :readOnly="true"
                                    >
                                    </nut-rate>
                                </div>
                                <div v-else-if="item.score <20">
                                    <nut-rate
                                        value="3"
                                        size="14"
                                        spacing="1"
                                        :readOnly="true"
                                    >
                                    </nut-rate>
                                </div>
                            </div>
                        </div>
                        <div class="content-box">
                            <div class="content">{{item.content}}</div>
                            <div class="sku">{{item.order_goods.goods_attr}}</div>
                            <div class="comment-images" v-if="item.image.length">
                                <div class="image-preview" v-for="(image,imgIndex) in item.image" :key="imgIndex">
                                    <a class="img" :href="image.file_path" target="_blank"><img :src="image.file_path"></a>
                                </div>
                            </div>
                            <div class="time">{{item.create_time}}</div>
                        </div>
                    </div>
                </div>
            </nut-infiniteloading>
            <!-- no-result -->
            <div class="noresult" v-if="!common_list.length">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #aaa">暂无评论内容</p>
                </div>
            </div>
        </div>
        <!-- favor end -->
    </div>
</template>
<script>
export default {
    name: 'GoodsCommon',
    data() { //默认数据
        return {
            noresult: false,
            isHasMore: true,
            isLoading: false,
            current_page: 1,
            last_page: 1,
            goods_id: 0,
            common_list: [],
            total: {},
            scoreType: -1,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
        _this.goods_id = _this.$route.query.goods_id;
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.getCommonList();

    },
    methods: {

        // 获取收藏列表
        getCommonList(page = 1) {
            let _this = this;
            _this._get('comment/lists', {
                page,
                goods_id: _this.goods_id,
                scoreType: _this.scoreType,
            }, res => {
                _this.total = res.data.total
                _this.common_list = _this.common_list.concat(res.data.list.data)
                _this.current_page = res.data.list.current_page
                _this.last_page = res.data.list.last_page
                _this.isHasMore = res.data.list.data ? true : false
                _this.loading.hide();
                _this.isLoading = false;
            })
        },

        swichNav(e){
            this.scoreType = e;
            this.common_list = [];
            this.getCommonList();
        },

        /**
         *  触底加载
         */
        loadMoreVert() {
            if (this.current_page >= this.last_page) {
                this.isLoading = false;
                this.isHasMore = false;
                return false;
            }
            this.isLoading = true;
            this.isHasMore = true;
            this.getCommonList(this.current_page + 1);
        },

    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
        _this.loading.hide();
    }
}
</script>
<style lang="scss">
@import "common.scss";
</style>
